import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.54138 3.75C6.64401 3.75 5.80309 4.18783 5.28849 4.92298L2.63759 8.70997L2.07468 8.65368C1.66253 8.61246 1.29499 8.91317 1.25378 9.32533C1.21256 9.73749 1.51327 10.105 1.92543 10.1462L2.25006 10.1787V17.25C2.25006 18.6307 3.36934 19.75 4.75006 19.75C6.13077 19.75 7.25006 18.6307 7.25006 17.25H16.7501C16.7501 18.6307 17.8693 19.75 19.2501 19.75C20.6308 19.75 21.7501 18.6307 21.7501 17.25V10.1787L22.0747 10.1462C22.4868 10.105 22.7875 9.73749 22.7463 9.32533C22.7051 8.91317 22.3376 8.61246 21.9254 8.65368L21.3625 8.70997L18.7116 4.92298C18.197 4.18783 17.3561 3.75 16.4588 3.75H7.54138ZM19.6502 8.87945L17.4828 5.78317C17.2489 5.44901 16.8666 5.25 16.4588 5.25H7.54138C7.13348 5.25 6.75125 5.44901 6.51734 5.78317L4.34994 8.87945C9.43895 9.35484 14.5612 9.35484 19.6502 8.87945ZM5.25204 12.3251C5.28198 11.912 5.64117 11.6013 6.0543 11.6313C6.71455 11.6791 7.37524 11.719 8.03622 11.7509C8.44996 11.7709 8.76917 12.1224 8.74921 12.5362C8.72925 12.9499 8.37767 13.2691 7.96393 13.2492C7.2909 13.2167 6.61816 13.1761 5.94586 13.1273C5.53273 13.0974 5.2221 12.7382 5.25204 12.3251ZM18.7482 12.3251C18.7781 12.7382 18.4675 13.0974 18.0543 13.1273C17.382 13.1761 16.7093 13.2167 16.0363 13.2492C15.6225 13.2691 15.271 12.9499 15.251 12.5362C15.231 12.1224 15.5502 11.7709 15.964 11.7509C16.625 11.719 17.2856 11.6791 17.9459 11.6313C18.359 11.6013 18.7182 11.912 18.7482 12.3251Z"
        fill={colorValue}
      />
    </svg>
  );
};
